import { PRODUCT } from "@constants/images";
const ProductCard = ({ title, desc, link }: any) => {
  return (
    <div className="product-card">
      <h2 className="pc-heading">{title}</h2>
      <p className="pc-desc">{desc}</p>
      <button className="btn learn-more-size" onClick={() => window.open(link, "_blank")}>learn more</button>
    </div>
  );
};

export default ProductCard;
